import React from 'react'
import { Typography } from 'antd'
import { WarningOutlined } from '@ant-design/icons'
import { useIntl } from 'react-intl'
import IntlMessages from '@vacationtracker/shared/components/utils/IntlMessages'
import DepartmentSelector from './DepartmentSelector'
import { IDepartmentPill } from '@vacationtracker/shared/types/team-energy'
import { formatShortDate } from '../utils/formatShortDate'
import VotitoSurveyConnected from '../../../components/votito-survey/VotitoSurveyConnected'

// Dedicated Votito survey for Team Energy feedback.
const TEAM_ENERGY_SURVEY_ID = '75eecfb3-f92a-4287-85b7-bb7a23aba219'

interface ITeamEnergyHeaderProps {
  snapshotAt: string | null
  isStale: boolean
  departments: IDepartmentPill[]
  selectedDepartmentId: string | null
  onSelectDepartment: (id: string) => void
}

const TeamEnergyHeader: React.FC<ITeamEnergyHeaderProps> = ({ snapshotAt, isStale, departments, selectedDepartmentId, onSelectDepartment }) => {
  const { formatMessage, locale } = useIntl()

  return (
    <div className="te-header">
      <div className="te-header__top">
        <div className="te-header__intro">
          <Typography.Title level={3} className="te-header__title">
            <IntlMessages id="teamEnergy.eyebrow" />
          </Typography.Title>
          {snapshotAt && (
            <Typography.Text type={isStale ? undefined : 'secondary'} className={isStale ? 'te-header__updated te-header__updated--stale' : 'te-header__updated'}>
              {isStale && <WarningOutlined className="te-header__updated-icon" />}
              {formatMessage({ id: isStale ? 'teamEnergy.updatedStale' : 'teamEnergy.updated' }, { date: formatShortDate(snapshotAt, locale, { withYear: true }) })}
            </Typography.Text>
          )}
        </div>
        <VotitoSurveyConnected surveyId={TEAM_ENERGY_SURVEY_ID} autoTrigger={false} />
      </div>
      {departments?.length > 0 && (
        <div className="te-header__selector">
          <Typography.Text type="secondary" className="te-header__selector-label">
            <IntlMessages id="app.department" />
          </Typography.Text>
          <DepartmentSelector departments={departments} selectedId={selectedDepartmentId} onSelect={onSelectDepartment} />
        </div>
      )}
    </div>
  )
}

export default TeamEnergyHeader
